import EthGasWatchApi from "common/api/EthGasWatchApi"

const ethGasWatchApi = new EthGasWatchApi()

export { ethGasWatchApi }
